import { marked } from 'marked';
import DOMPurify from 'dompurify';

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName !== 'A') return;
  try {
    const url = new URL(node.getAttribute('href') || '');
    if (!/^https?:$/.test(url.protocol) || url.username || url.password) throw new Error('无效来源链接');
    node.setAttribute('href', url.href);
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  } catch {
    node.removeAttribute('href');
    node.removeAttribute('target');
    node.removeAttribute('rel');
  }
});

const renderer = new marked.Renderer();
const renderTable = renderer.table.bind(renderer);
renderer.table = (header, body) => {
  return `<div class="markdown-table" role="region" aria-label="表格，可横向滚动" tabindex="0">${renderTable(header, body)}</div>`;
};

marked.setOptions({ renderer, gfm: true, breaks: true });

const purifyConfig = {
  ALLOWED_TAGS: [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
    'li', 'b', 'i', 'strong', 'em', 'strike', 'del', 'code', 'hr', 'br', 'div',
    'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre', 'span', 'input'
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'type', 'checked', 'disabled',
    'align', 'start', 'role', 'aria-label', 'tabindex']
};

// Markdown 的段落、列表、表格和代码由解析器处理，不补写或改写用户原文。
export const renderMarkdown = (content) => {
  const rawHtml = marked.parse(`${content || ''}`.replace(/\r\n/g, '\n'));
  return DOMPurify.sanitize(rawHtml, purifyConfig);
};
